<template>
  <div class="personalInformation">
    <div class="contair">
      <div class="topBox" v-if="isPerfect">
        <p>您的个人信息尚未完善，请完善个人信息</p>
        <p @click="closeTips()" class="tipBox">X</p>
      </div>
      <div class="titleBox">
        <div class="redBox"></div>
        <p>我的基本信息</p>
      </div>
      <el-row :gutter="10">
        <el-col :span="4" class="leftBox">
          <el-upload class="avatar-uploader" action="#" name="file" :show-file-list="false" :http-request="handleUpload"
            :on-success="handleAvatarSuccess" :on-error="handleAvatarError" :before-upload="beforeAvatarUpload">
            <div slot="tip" class="el-upload__tip" style="color: rgb(0, 193, 222);">上传头像要求：只能上传jpg/png/bmp文件，且不超过2Mb</div>
            <img v-if="information.photo" :src="$store.state.defaultPicUrl+information.photo" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-col>
        <el-col :span="18">
          <el-row>
            <el-col :span="4" class="inputNameA">登录账号:</el-col>
            <el-col :span="18" class="content">
              <el-col :span="4" class="nameBox">{{information.account}}</el-col>
              <el-col :span="3" class="minheight"></el-col>
              <el-col :span="3">
                <div class="changePass">
                  <span class="passworld" @click="routerLinkTo('password')">修改密码</span>
                  <!-- <router-link to="/memberCenterIndex/changePass" class="passworld">修改密码</router-link> -->
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="inputNameB">昵称:</el-col>
            <el-col :span="18" class="marTop5">
              <el-col :span="10">
                <el-input type="text" placeholder="请输入内容" v-model="information.nickname" maxlength="14" show-word-limit
                  class="nameInput">
                </el-input>
              </el-col>

            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="inputName">手机号:</el-col>
            <el-col :span="18" class="marTop5">
              <el-col :span="10">
                <el-input class="userName phoneInput" disabled="disabled" v-model="information.mobile"></el-input>
              </el-col>
              <el-col :span="3" class="change">
                <span class="tochange" @click="routerLinkTo('mobile')">修改</span>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="inputName">邮箱:</el-col>
            <el-col :span="18" class="marTop5">
              <el-col :span="10">
                <el-input class="userName phoneInput" disabled="disabled" v-model="information.email"></el-input>
              </el-col>
              <el-col :span="3" class="change">
                <span class="tochange" @click="routerLinkTo('email')">修改</span>
              </el-col>
            </el-col>
          </el-row>
        <!--  <el-row>
            <el-col :span="4" class="inputName">微信:</el-col>
            <el-col :span="18" v-if="information.wxChat !==''" class="marTop5">
              <el-col :span="10"><input class="userName" disabled="disabled" /></el-col>
              <el-col :span="3" class="change"><span>修改</span></el-col>
            </el-col>
           <el-col :span="18" class="marTop5" v-else>
              <el-col :span="3" class="change"><span>绑定微信</span></el-col>
            </el-col>
          </el-row> -->
        </el-col>
      </el-row>
      <div class="titleBox">
        <div class="redBox"></div>
        <p>我的个人信息</p>
      </div>
		
      <el-row :gutter="10">
        <el-col :span="4" class="minheight">
        </el-col>
        <el-col :span="18">
          <el-row>
            <el-col :span="4" class="inputName">性别:</el-col>
            <el-col :span="18" class="marTop5">
              <el-col :span="10">
                <el-radio v-model="information.sex" label="男">男</el-radio>
                <el-radio v-model="information.sex" label="女">女</el-radio>
              </el-col>
            </el-col>
          </el-row>
		  <el-row>
		    <el-col :span="4" class="inputName">真实姓名:</el-col>
		    <el-col :span="18" class="marTop5">
		      <el-col :span="10">
		        <el-input class="userName" v-model="information.name"></el-input>
		      </el-col>
		    </el-col>
		  </el-row>
		  <el-row>
		    <el-col :span="4" class="inputName">所属公司:</el-col>
		    <el-col :span="18" class="marTop5">
		      <el-col :span="10">
		        <el-input class="userName" v-model="information.remark2"></el-input>
		      </el-col>
		    </el-col>
		  </el-row>
          <el-row>
            <el-col :span="4" class="inputName">部门及职务:</el-col>
            <el-col :span="18" class="marTop5">
              <el-col :span="10">
                <el-input class="userName" v-model="information.profession"></el-input>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="inputName">出生日期:</el-col>
            <el-col :span="18" class="marTop5">
              <el-col :span="10">
                <el-date-picker class="userName" v-model="information.birth" type="date" placeholder="选择日期">
                </el-date-picker>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="inputName">住址:</el-col>
            <el-col :span="18" class="marTop5">
              <el-col :span="10">
                <el-input class="userName" v-model="information.location"></el-input>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="inputName">行政区域:</el-col>
            <el-col :span="18" class="marTop5">
              <el-col :span="10">
                <!-- Customize region toggle -->
                <v-region class="userName" type="group"  @values="regionChange">
                  <el-input class="userName" v-model="information.workaddress"></el-input>
                </v-region>

                <!-- <v-region @values="regionChange" class="form-control" t></v-region>
                <el-input class="userName" v-model="information.workaddress"></el-input> -->
              </el-col>
            </el-col>
          </el-row>
        <!--  <el-row>
            <el-col :span="4" class="inputName">公司:</el-col>
            <el-col :span="18" class="marTop5">
              <el-col :span="10">
                <el-input class="userName" v-model="information.company"></el-input>
              </el-col>
            </el-col>
          </el-row> -->
          <el-row class="bottomBox">
            <el-col :span="4" class="minheight"></el-col>
            <el-col :span="18" class="marTop5">
              <el-col :span="10"><button class="saveButton" @click="saveInformation()">保存</button></el-col>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  export default ({
    name: 'personalInformation',
    data() {
      return {
        isPerfect: true,
        information: {
          userId: this.$store.state.userId, //登录账号id
          account: '',
          nickname: '',
		  name: '',
          mobile: '',
          email: '',
          wxChat: '',
          sex: '',
		  remark2: '',
          profession: '',
          birth: '',
          workaddress: '',
          location: '',
          company: '',
          photo: '',
          fileName: '',
          filePath: '',
          filePreviewPath: ''
        },
        imageUrl: ''
      }
    },
    created: function() {
      //1.初始化加载账号信息
      this.loadInformation();
    },
    methods: {
      //选择区域  data = {area: null,city: null,province: {key: "110000", value: "北京市"},town: null}
      regionChange(data) {

        let selected = '';
        //省/直辖市
        if(data.province){
          if(selected)selected += "/";
          selected += data.province.value;
        }
        //城市
        if(data.city){
          if(selected)selected += "/";
          selected += data.city.value;
        }
        //区/县
        if(data.area){
          if(selected)selected += "/";
          selected += data.area.value;
        }
        //乡/镇/街道
        if(data.town){
          if(selected)selected += "/";
          selected += data.town.value;
        }
        this.information.workaddress = selected;

        // console.log(data);
        // this.information.workaddress = data.
      },
      closeTips() {
        this.isPerfect = false;
      },
      //格式化属性（处理undefined、空值属性）
      formatProperty(fProperty) {
        if (fProperty == undefined || fProperty == '') {
          fProperty = '';
        }
        return fProperty;
      },
      //加载账号信息
      loadInformation() {
        if (this.information.userId === '') {
          return;
        }
        let this_ = this;

        let paramdata = {};
        paramdata.data = {
          "userId": this_.information.userId
        }; //json对象
        paramdata.url = '/jwt/user/getUserInfo';

        paramdata.onSuccess = function(res) {

          if (res.data.ok && res.data.result) {

            let userInfo = res.data.result.userInfo;
            let memberInfo = res.data.result.memberInfo;
            let filePreviewPath = res.data.result.filePreviewPath;

            let information = this_.information;
            if (userInfo) {
              information.account = this_.formatProperty(userInfo.loginName);
			  information.name = this_.formatProperty(userInfo.name);
              information.mobile = this_.formatProperty(userInfo.mobile);
              information.company = userInfo.company != undefined ? userInfo.company.name : '';
              information.photo = this_.formatProperty(userInfo.photo);
            }
            //头像预览地址
            information.filePreviewPath = this_.formatProperty(filePreviewPath);

            if (memberInfo) {
              // filePath 头像地址 fileName 头像名称
              information.photoUrl = this_.formatProperty(memberInfo.filePath) + this_.formatProperty(memberInfo.fileName);
              information.email = this_.formatProperty(memberInfo.email);
              information.wxChat = this_.formatProperty(memberInfo.wxId);
              information.sex = this_.formatProperty(memberInfo.sex);
			  information.nickname = this_.formatProperty(memberInfo.nickname);
			  information.name = this_.formatProperty(memberInfo.name);
			  information.remark2 = this_.formatProperty(memberInfo.remark2);
              information.profession = this_.formatProperty(memberInfo.profession);
              information.birth = this_.formatProperty(memberInfo.birthday);
              information.location = this_.formatProperty(memberInfo.location);
              information.workaddress = this_.formatProperty(memberInfo.workaddress);
              information.fileName = this_.formatProperty(memberInfo.fileName);
              information.filePath = this_.formatProperty(memberInfo.filePath);
            }
            this_.information = information;

          } else {
            // let errmsg = res.data.appendmes != undefined ? res.data.appendmes : res.data.errmsg;
          }
        };
        paramdata.onFailed = function(res) {
          console.log(res);
        };
        this_.$axiosUtil.postServer(paramdata);
      },
      saveInformation() {
        let this_ = this;
        let paramdata = {};
        paramdata.data = this_.information; //json对象
        paramdata.data.wxId = this_.information.wxChat;
        paramdata.data.birthday = this_.information.birth;
        paramdata.data.nickname = this_.information.nickname;
		paramdata.data.name = this_.information.name;
		paramdata.data.remark2 = this_.information.remark2;
		paramdata.data.remark2 = this_.information.remark2;
        paramdata.data.systemcode = this.$store.state.systemcode; //系统编号
        paramdata.data.client = this.$store.state.defaultClient;
        paramdata.data.clientSys = this.$store.state.defaultClientSys;
     
        paramdata.url = '/jwt/user/saveUserInfoAndMemberIfo';

        paramdata.onSuccess = function(res) {

          if (res.data.ok && res.data.result) {
            this_.$message({
              message: '保存成功！',
              type: 'success'
            });
            //更新显示昵称
            this_.$store.commit('updateUser', {
              'user': this_.information.name
            });
            //重新加载当前页信息
            this_.loadInformation();

          } else {
            let errmsg = res.data.appendmes != undefined ? res.data.appendmes : res.data.errmsg;
            this_.$message({
              message: '保存失败！' + errmsg,
              type: 'warning'
            });
          }
        };
        paramdata.onFailed = function(res) {
          console.log(res);
        };
        this_.$axiosUtil.postServer(paramdata);
      },
      // 修改跳转
      routerLinkTo(m) {
        if (m == 'mobile') {
          //设置手机号(修改页面接收验证码手机号)
          sessionStorage.setItem('mobile', this.information.mobile);
          this.$router.push("/memberCenterIndex/changeMobile"); //跳转修改手机号页面
        } else if (m == 'email') {
          //设置手机号(修改页面接收验证码手机号)
          sessionStorage.setItem('mobile', this.information.mobile);
          this.$router.push("/memberCenterIndex/changeEmail"); //跳转修改邮箱页面
        } else if (m == 'password') {
          //设置手机号(修改页面接收验证码手机号)
          sessionStorage.setItem('mobile', this.information.mobile);
          this.$router.push("/memberCenterIndex/changePass"); //跳转修改密码页面
        }
      },
      //文件上传成功的回调
      handleAvatarSuccess(res, file) {
        if (res.ok) {
          //更新显示昵称
          this.$store.commit('updateUser', {
            'userImage': res.result.filePath + res.result.fileName
          });
          this.information.fileName = res.result.fileName;
          this.information.filePath = res.result.filePath;
          this.information.filePreviewPath = res.result.filePreviewPath;
          this.information.photo = res.result.filePath + res.result.fileName;
        } else {
          let errmsg = res.errmsg;
          if (!errmsg)
            errmsg = '上传头像图片失败!';
          this.$message.error(errmsg);
        }
      },
      //文件上传失败的回调
      handleAvatarError(err, file, fileList) {
        console.log(err);
      },

      beforeAvatarUpload(file) { //头像文件验证
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isBMP = file.type === 'image/bmp';
        const isLt2M = file.size / 1024 / 1024 < 2;

        let ispass = true; //通过标识
        if (!isJPG && !isPNG && !isBMP) {
          this.$message.error('上传头像图片只能是 JPG/GIF/PNG/BMP 格式!');
          ispass = false;
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
          ispass = false;
        }
        return ispass;
      },
      //这个file参数 转base64字符串
      getBase64(file) {
        return new Promise((resolve, reject) => {
          let reader = new FileReader();
          let fileResult = "";
          reader.readAsDataURL(file);
          //开始转
          reader.onload = function() {
            fileResult = reader.result;
          };
          //转 失败
          reader.onerror = function(error) {
            reject(error);
          };
          //转 结束  咱就 resolve 出去
          reader.onloadend = function() {
            resolve(fileResult);
          };
        });
      },
      //上传
      handleUpload(data) {
        let this_ = this;
        //文件名
        let fileName = data.file.name;
        //文件类型
        let fileType = data.file.type;
        //文件大小
        let fileSize = data.file.size;
        //文件后缀
        let subfix = data.file.name.substring(data.file.name.lastIndexOf('.'));
        // 1.附件转base64
        this.getBase64(data.file).then(resBase64 => {
          // 获取文件base64字符串
          let base64Str = resBase64.split(',')[1];
          let paramdata = {};
          paramdata.data = {
            'userId': this_.information.userId,
            'modelname': 'sjhgHeadPic',
            'base64Str': base64Str,
            'fileName': fileName,
            'fileType': fileType,
            'fileSize': fileSize,
            'subfix': subfix,
            "nickname" : this_.$store.state.user,
            "client": this_.$store.state.defaultClient,
            "clientSys": this_.$store.state.defaultClientSys,
            "systemcode":this_.$store.state.systemcode //系统编号
          };
          paramdata.url = '/jwt/user/savePhoto';
          paramdata.onSuccess = function(res) {
            this_.handleAvatarSuccess(res.data);
          };
          paramdata.onFailed = function(res) {
            console.log(res);
          };
          this_.$axiosUtil.postServer(paramdata);
        })
      }
    }
  })
</script>

<style lang="scss" scoped>
  p {
    margin: 0;
    padding: 0;
  }

  .personalInformation {
    width: 100%;
    height: 100%;
  }

  .marTop5 {
    margin-top: 5px;
  }

  .contair {
    width: 1280px;
    margin: 0px auto;
    padding-top: 5px;
  }

  .topBox {
    display: flex;
    height: 40px;
    border: 1px solid rgb(0, 193, 222);
    padding: 0px 10px;
    margin-top: 10px;
  }

  .topBox>p {
    margin: 0px;
    padding: 0px;
    font-size: 12px;
    line-height: 40px;
    color: rgb(0, 193, 222);
  }

  .topBox>p:first-of-type {
    width: 95%;
    text-align: left;
  }

  .topBox>p:last-of-type {
    width: 5%;
    text-align: right;
  }

  .tipBox:hover {
    cursor: pointer;
  }

  .titleBox {
    border-bottom: 1px solid #e6e7ec;
    margin-top: 20px;
    margin-bottom: 15px;
    display: flex;
  }

  .titleBox>p {
    line-height: 28px;
    height: 32px;
    font-size: 18px;
    color: #222;
  }

  .redBox {
    height: 18px;
    margin-top: 4px;
    background: $color-primary;
    width: 4px;
    margin-right: 3px;
  }

  .leftBox {
    padding-top: 30px;
  }

  .leftBox>img {
    width: 100px;
    height: 100px;
    border-radius: 40px;
    margin-left: 40%;
  }

  .sendImg {
    font-size: 14px;
    line-height: 30px;
    background: $color-primary;
    color: #ffffff;
    width: 100px;
    text-align: center;
    margin-left: 40%;
    margin-top: 5px;
  }

  .sendImg:hover {
    background: $color-primary-light-1;
    cursor: pointer;
  }
  .userName {
     width: 100%;
    }
  .userName>input {
    width: 100%;
    height: 35px;
    margin-top: 5px;
    padding: 0 15px;
    box-sizing: border-box;
    color: #555;
    line-height: 35px;
    border: 1px solid #C0C4CC;
  }

  .inputNameA {
    text-align: right;
    padding-right: 30px;
    line-height: 35px;
    color: #444;
    font-size: 15px;
  }

  .inputNameB {
    text-align: right;
    padding-right: 30px;
    line-height: 35px;
    color: #444;
    font-size: 15px;
    margin-top: 5px;
  }

  .inputName {
    text-align: right;
    padding-right: 30px;
    line-height: 35px;
    margin-top: 5px;
    color: #444;
    font-size: 15px;
  }

  .minheight {
    min-height: 1px;
  }

  .changePass {
    background: $color-primary;
    color: #ffffff;
    text-align: center;
    height: 30px;
    line-height: 30px;
    margin-top: 2px;
  }

  .changePass:hover {
    background: $color-primary-light-1;
    cursor: pointer;
  }

  .content {
    height: 40px;
  }

  .nameBox {
    line-height: 35px;
    color: #666;
  }

  .change {
    height: 35px;
    line-height: 35px;
    margin-left: 10px;
    color: $color-primary;
    font-size: 15px;
  }

  .change>span:hover {
    cursor: pointer;
  }

  .saveButton {
    padding: 7px 30px;
    background: $color-primary;
    color: #ffffff;
    border: 1px solid $color-primary;
    float: right;
    margin-top: 20px;
    font-size: 16px;
  }

  .saveButton:hover {
    background: $color-primary-light-1;
    cursor: pointer;
  }

  >>>.el-input.is-active .el-input__inner,
  .el-input__inner:focus {
    border-color: $color-primary !important;
    outline: 0;
  }

  >>>.el-input__inner {
    height: 35px;
    line-height: 35px;
    color: #666;
    border-radius: 0px;
  }

  .el-row {
    margin-top: 5px;
  }

  .passworld {
    color: #ffffff;
    text-decoration: none;
    font-size: 15px;
  }

  .tochange {
    text-decoration: none;
    color: $color-primary;
    font-size: 15px;
  }

  .bottomBox {
    margin-top: 15px;
  }

  .phoneInput {
    background: rgba(235, 235, 228, .4);
  }

  // ========================头像上传
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  >>>div.rg-caller-container{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/page/memberCenter/personalInformation.vue